var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "px-ogs py-22",
      class: `text-${_vm.textColour}`,
      style: { backgroundColor: _vm.backgroundColour },
    },
    [
      _c("div", { staticClass: "grid grid-cols-12 gap-x-ogs" }, [
        _c(
          "div",
          {
            staticClass:
              "col-span-12 md:col-span-6 xl:col-span-4 xl:pl-7 mb-14",
          },
          [
            _vm.headingRich
              ? _c("div", {
                  staticClass:
                    "text-xl md:text-4xl leading-tight mb-4 md:mb-10",
                  domProps: { innerHTML: _vm._s(_vm.headingRich) },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.body
              ? _c("div", {
                  staticClass: "text-sm",
                  domProps: { innerHTML: _vm._s(_vm.body) },
                })
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "col-span-12 md:col-span-6 xl:col-span-6 xl:col-start-7",
          },
          [
            _c(
              "div",
              {
                staticClass: "border-b",
                class: {
                  "border-white": _vm.textColour === "white",
                  "border-black": _vm.textColour === "black",
                },
              },
              _vm._l(_vm.items, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "border-t",
                    class: {
                      "border-white": _vm.textColour === "white",
                      "border-black": _vm.textColour === "black",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex items-center w-full text-left leading-snug py-5 pr-2",
                        class: {
                          "py-5 lg:py-3": _vm.style === "large",
                          "py-5": _vm.style === "default",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex-1 flex items-center justify-between pr-4",
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "link text-left pr-4",
                                on: {
                                  click: function ($event) {
                                    _vm.activeItem =
                                      _vm.activeItem === index ? null : index
                                  },
                                },
                              },
                              [
                                _c(
                                  "h4",
                                  {
                                    staticClass: "leading-tight",
                                    class: {
                                      "text-xl lg:text-4xl":
                                        _vm.style === "large",
                                      "text-xl": _vm.style === "default",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(item.heading) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            item.linkUrl
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "hidden md:block transition-opacity duration-300 opacity-0 hover:underline",
                                    class: {
                                      "opacity-100": _vm.activeItem === index,
                                    },
                                    attrs: { href: item.linkUrl },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        item.linkTitle
                                          ? item.linkTitle
                                          : item.linkUrl
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "link flex-shrink-0 w-5 h-5 md:w-6 md:h-6 transition duration-300",
                            style: {
                              transform:
                                _vm.activeItem === index
                                  ? "rotate(135deg)"
                                  : "rotate(0)",
                            },
                            on: {
                              click: function ($event) {
                                _vm.activeItem =
                                  _vm.activeItem === index ? null : index
                              },
                            },
                          },
                          [
                            _c("IconAdd"),
                            _vm._v(" "),
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v("Read more about " + _vm._s(item.heading)),
                            ]),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.activeItem === index
                      ? _c(
                          "div",
                          {
                            staticClass: "border-t py-7",
                            class: {
                              "border-white": _vm.textColour === "white",
                              "border-black": _vm.textColour === "black",
                            },
                          },
                          [
                            item.linkUrl
                              ? _c("p", { staticClass: "mb-4 md:hidden" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "underline",
                                      attrs: { href: item.linkUrl },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.linkTitle
                                            ? item.linkTitle
                                            : item.linkUrl
                                        )
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(_vm.nl2br(item.body)),
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }